// extracted by mini-css-extract-plugin
export var actionButton = "_5i-1";
export var actionButtons = "_5i-2";
export var actions = "_5i-0";
export var aiUnread = "_5i-10";
export var alignCenter = "_5i-h";
export var backWrapper = "_5i-3";
export var cellContainer = "_5i-4";
export var checkboxContainer = "_5i-5";
export var contentContainer = "_5i-6";
export var contentHeader = "_5i-8";
export var conversationsTableWrapper = "_5i-s";
export var draftReplyBadgeContainer = "_5i-m";
export var dropdownItem = "_5i-b";
export var dropdownItemsContainer = "_5i-a";
export var dropdownTitle = "_5i-c";
export var errorIcon = "_5i-7";
export var filter = "_5i-d";
export var gray = "_5i-i";
export var headerActionButtons = "_5i-e";
export var headerCheckboxContainer = "_5i-f";
export var icon = "_5i-j";
export var menuContainer = "_5i-k";
export var noMoreTicketsIcon = "_5i-12";
export var noMoreTicketsSubText = "_5i-13";
export var oneLine = "_5i-l";
export var optionsButton = "_5i-n";
export var plus = "_5i-o";
export var portalButtonsWrapper = "_5i-g";
export var red = "_5i-p";
export var scrolledTop = "_5i-9";
export var search = "_5i-q";
export var selectedConversationsCount = "_5i-r";
export var spinner = "_5i-t";
export var strong = "_5i-u";
export var summaryCell = "_5i-v";
export var tableContainer = "_5i-11";
export var tagContainer = "_5i-w";
export var threeDots = "_5i-x";
export var twoLines = "_5i-y";
export var unread = "_5i-z";